import { render } from "./NotificationCreate.vue?vue&type=template&id=671adfe0&scoped=true"
import script from "./NotificationCreate.vue?vue&type=script&lang=js"
export * from "./NotificationCreate.vue?vue&type=script&lang=js"

import "./NotificationCreate.vue?vue&type=style&index=0&id=671adfe0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671adfe0"]])

export default __exports__